import ToastHighLighter from '@/lib/ToastHighLighter';

export const ModalCode = () => {
  const language = 'html';
  const codeString = `
  // Modal
  <div
    class="modal fade"
    id="exampleModal"
    tabIndex={-1}
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title fs-5" id="exampleModalLabel">
            Modal title
          </h4>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>
        <div class="modal-body">
          Modal content ...
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            data-bs-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
  `;

  return (
    <>
      <ToastHighLighter
        name={'modal'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
